import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PermitTableRow = ({ permit, isSelected, onSelect, onViewDetails, onExtend, onClose }) => {
  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
      pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
      expired: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
      extended: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
      closed: 'bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-400'
    };
    return colors?.[status] || colors?.pending;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors">
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(permit?.id, e?.target?.checked)}
          className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary/20"
          aria-label={`Select permit ${permit?.permitId}`}
        />
      </td>
      <td className="px-4 py-3">
        <span className="font-mono text-sm font-medium text-foreground">{permit?.permitId}</span>
      </td>
      <td className="px-4 py-3">
        <div className="max-w-xs">
          <p className="text-sm font-medium text-foreground truncate">{permit?.workDescription}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{permit?.permitType}</p>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={14} className="text-muted-foreground" />
          <span className="text-sm text-foreground">{permit?.location}</span>
        </div>
      </td>
      <td className="px-4 py-3">
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(permit?.status)}`}>
          {permit?.status?.charAt(0)?.toUpperCase() + permit?.status?.slice(1)}
        </span>
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="User" size={16} className="text-primary" />
          </div>
          <span className="text-sm text-foreground">{permit?.assignedTo}</span>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="text-sm">
          <p className="text-foreground">{formatDate(permit?.startDate)}</p>
          <p className="text-muted-foreground text-xs mt-0.5">{formatDate(permit?.endDate)}</p>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onViewDetails(permit?.id)}
            title="View details"
          >
            View
          </Button>
          {permit?.status === 'active' && (
            <Button
              variant="outline"
              size="sm"
              iconName="Clock"
              onClick={() => onExtend(permit?.id)}
              title="Extend permit"
            >
              Extend
            </Button>
          )}
          {(permit?.status === 'active' || permit?.status === 'extended') && (
            <Button
              variant="ghost"
              size="sm"
              iconName="XCircle"
              onClick={() => onClose(permit?.id)}
              title="Close permit"
            >
              Close
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default PermitTableRow;